/**
 * Represents a generic mapper interface that defines methods for converting between raw data and entities.
 *
 * @template Raw - The type of the raw data.
 * @template Entity - The type of the entity.
 */

export class BaseMapper {}